export const isCmsUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();
    // Match cms.*.sli.ke pattern or local.sli.ke (for testing)
    return /^cms[^/]*\.sli\.ke$/.test(hostname) || /^local\.sli\.ke$/.test(hostname);
  } catch {
    const urlLower = url.toLowerCase();
    return /^https?:\/\/cms[^/]*\.sli\.ke/.test(urlLower) || /^https?:\/\/local\.sli\.ke/.test(urlLower);
  }
};

export const appendTokenToCmsRedirect = (redirectUrl: string, token?: string | null): string => {
  if (!token || !isCmsUrl(redirectUrl)) {
    return redirectUrl;
  }

  try {
    const url = new URL(redirectUrl);
    url.searchParams.set('token', token);
    return url.toString();
  } catch {
    const separator = redirectUrl.includes('?') ? '&' : '?';
    return `${redirectUrl}${separator}token=${encodeURIComponent(token)}`;
  }
};

/**
 * Gets the token from a login response
 * @param response - The login response object
 * @returns The token if found, undefined otherwise
 */
export const getTokenFromResponse = (response: { data?: { token?: string; jwt?: string }; token?: string }): string | undefined => {
  if (response?.data?.token) {
    return response.data.token;
  }
  
  if (response?.token) {
    return response.token;
  }
  
  return undefined;
};

